export const LINES_FRM_INFO = "LINES_FRM_INFO";
export const GET_CREATIVE_LIB = "GET_CREATIVE_LIB";
export const UPLOAD_CREATIVE = "UPLOAD_CREATIVE";
export const GET_ORDER_DETAILS = "GET_ORDER_DETAILS";
export const GET_ORDER_OUTLETS = "GET_ORDER_OUTLETS";
export const UPDATE_CAMPAIGN_EXISTS = "UPDATE_CAMPAIGN_EXISTS";
export const UPDATE_LINE_HISTORY = "UPDATE_LINE_HISTORY";
